/**
 * SchemasList
 */
import React from 'react';
import { connect } from 'react-redux';
import { createStructuredSelector } from 'reselect';
import { List } from 'semantic-ui-react';

// Components
import NoSearchResults from '../../../../../../components/NoSearchResults';
import SchemasListItem from './components/SchemasListItem';

// Selectors
import { selectIds } from './selectors';

interface Props {
    ids?: number[];
}

export class SchemasList extends React.PureComponent<Props> {
    render() {
        const { ids } = this.props;
        if (!ids || !ids.length) {
            return <NoSearchResults />;
        }
        return (
            <List divided relaxed>
                {ids.map(id => (
                    <SchemasListItem key={id} schemaId={id} />
                ))}
            </List>
        );
    }
}

const mapStateToProps = createStructuredSelector({
    ids: selectIds
});

export default connect(mapStateToProps)(SchemasList);
